export enum ExpertiseEnum {
  Arbeitsrecht = "arbeitsrecht",
  Erbrecht = "erbrecht",
  Gesellschaftsrecht = "gesellschaftsrecht",
  Startuprecht = "startuprecht",
  Steuerrecht = "steuerrecht",
  Prozessfuehrung = "prozessfuehrung",
  InternetMedienRecht = "internetmedienrecht",
  Insolvenzrecht = "insolvenzrecht",
}
